import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { CartResponse } from '../models/cart-response.model';
import { CartRepository } from '../repositories/cart.respository';

export class GetCartUseCase implements UseCase<never, CartResponse> {
    constructor(private readonly repository: CartRepository) {}

    execute(): Observable<CartResponse> {
        return this.repository.getCart();
    }
}
